import React, { useState } from "react";
import "./Contact.css";
import { API_BASE_URL } from "../config";

const LOCATIONS = {
  namakkal: {
    title: "Namakkal Training Center",
    address: "Namakkal, Tamil Nadu",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3912.113137918836!2d78.0272093!3d11.326440500000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babdbb297734803%3A0xd05a3e9e2582d7b4!2sFlytutor%20RPTO%20Training%20Cente!5e0!3m2!1sen!2sin!4v1756737038335!5m2!1sen!2sin",
  },
  bangalore: {
    title: "Bangalore Training Center",
    address: "Bangalore, Karnataka",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.7767777777776!2d77.5946!3d12.9716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sBangalore!5e0!3m2!1sen!2sin!4v1756737038336",
  },
};

const Contact = () => {
  const [activeLocation, setActiveLocation] = useState("namakkal");

  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    number: "",
    message: "",
  });
  const [contactStatus, setContactStatus] = useState("");

  const [partnerForm, setPartnerForm] = useState({
    name: "",
    email: "",
    number: "",
    message: "",
  });
  const [partnerStatus, setPartnerStatus] = useState("");
  const [contactLoading, setContactLoading] = useState(false);
  const [partnerLoading, setPartnerLoading] = useState(false);

  const handleChange = (e, type) => {
    const { name, value } = e.target;
    if (type === "contact") setContactForm((p) => ({ ...p, [name]: value }));
    else setPartnerForm((p) => ({ ...p, [name]: value }));
  };

  const handlePartnerSubmit = async (e) => {
    e.preventDefault();

    if (partnerLoading) return; // 🛑 BLOCK DOUBLE CLICK

    setPartnerLoading(true);
    setPartnerStatus("");

    try {
      const response = await fetch(
        `${API_BASE_URL}/adminpatnertouch`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(partnerForm),
        },
      );

      if (response.ok) {
        setPartnerStatus("✅ Message sent successfully!");
        setPartnerForm({ name: "", email: "", message: "" });
      } else {
        setPartnerStatus("❌ Failed to send message.");
      }
    } catch (err) {
      console.error("Partner submit error:", err);
      setPartnerStatus("⚠ Server error.");
    } finally {
      setPartnerLoading(false); // ✅ RE-ENABLE
    }
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();

    if (contactLoading) return;

    setContactLoading(true);
    setContactStatus("Sending...");

    try {
      const response = await fetch(`${API_BASE_URL}/home`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...contactForm,
          location: activeLocation,
        }),
      });

      if (response.ok) {
        setContactStatus("✅ Message sent successfully!");
        setContactForm({
          name: "",
          email: "",
          number: "",
          message: "",
        });
      } else {
        const errorData = await response.json();
        setContactStatus(errorData.message || "❌ Failed to send message.");
      }
    } catch (err) {
      console.error("Contact submit error:", err);
      setContactStatus("⚠ Server error. Please try again later.");
    } finally {
      setContactLoading(false);
    }
  };

  return (
    <section className="partners-section">
      {/* ===== BEING PARTNERS ===== */}
      <h2 className="flytutor-main-heading">Being Partners</h2>
      <p className="partners-subtitle">
        Join hands with us and be a part of the growing drone ecosystem.
      </p>

      <div className="partners-grid">
        {[
          "🤝 Collaboration",
          "💼 Business Growth",
          "🎓 Knowledge Sharing",
          "🌍 Global Network",
        ].map((t, i) => (
          <div className="partner-card" key={i}>
            <div className="partner-icon">{t.split(" ")[0]}</div>
            <h3>{t.slice(2)}</h3>
            <p>Partner with Flytutor and grow together.</p>
          </div>
        ))}
      </div>

      {/* ===== PARTNER FORM ===== */}
      <div className="partner-form-container">
        <h3 className="flytutor-main-heading" style={{ fontSize: '2rem', paddingBottom: '10px' }}>Become a Partner</h3>
        <form className="partner-form" onSubmit={handlePartnerSubmit}>
          <input
            name="name"
            placeholder="Your Name"
            value={partnerForm.name}
            onChange={(e) => handleChange(e, "partner")}
            required
          />
          <input
            name="email"
            placeholder="Your Email"
            value={partnerForm.email}
            onChange={(e) => handleChange(e, "partner")}
            required
          />
          <input
            name="number"
            placeholder="Your Phone Number"
            value={partnerForm.number}
            onChange={(e) => handleChange(e, "partner")}
            required
          />
          <textarea
            name="message"
            placeholder="Tell us about your partnership idea..."
            value={partnerForm.message}
            onChange={(e) => handleChange(e, "partner")}
            required
          />
          <button type="submit" disabled={partnerLoading}>
            {partnerLoading ? "Submitting..." : "Submit"}
          </button>
        </form>
        {partnerStatus && <p className="form-status">{partnerStatus}</p>}
      </div>

      {/* ===== CONTACT SECTION ===== */}
      <div className="contact-page">
        <h2 className="contact-title">Contact Us</h2>
        <p className="contact-subtitle">
          Select your preferred training facility and connect with our aviation experts.
        </p>

        {/* LOCATION SWITCH */}
        <div className="location-switch">
          <button
            className={activeLocation === "namakkal" ? "active" : ""}
            onClick={() => setActiveLocation("namakkal")}
          >
            Namakkal
          </button>
          <button
            className={activeLocation === "bangalore" ? "active" : ""}
            onClick={() => setActiveLocation("bangalore")}
          >
            Bangalore <span className="new-badge">NEW</span>
          </button>
        </div>

        <div className="contact-grid">
          {/* MAP */}
          <div className="contact-left">
            <div className="map-container">
              <iframe
                key={activeLocation}
                src={LOCATIONS[activeLocation].map}
                title={LOCATIONS[activeLocation].title}
                loading="lazy"
              />
            </div>
            <p className="map-caption">
              📍 {LOCATIONS[activeLocation].title} –{" "}
              {LOCATIONS[activeLocation].address}
            </p>
          </div>

          {/* FORM */}
          <div className="contact-right">
            <h3>Send a Message</h3>
            <form onSubmit={handleContactSubmit}>
              <input
                name="name"
                placeholder="Full Name"
                value={contactForm.name}
                onChange={(e) => handleChange(e, "contact")}
                required
              />
              <input
                name="email"
                placeholder="Email Address"
                value={contactForm.email}
                onChange={(e) => handleChange(e, "contact")}
                required
              />
              <input
                name="number"
                placeholder="Phone Number"
                value={contactForm.number}
                onChange={(e) => handleChange(e, "contact")}
                required
              />
              <textarea
                name="message"
                placeholder="Your message..."
                value={contactForm.message}
                onChange={(e) => handleChange(e, "contact")}
                required
              />
              <button
                type="submit"
                className="contact-btn"
                disabled={contactLoading}
              >
                {contactLoading ? "Sending..." : "Send Message"}
              </button>
            </form>
            {contactStatus && <p className="form-status">{contactStatus}</p>}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
